import React, {useEffect, useRef, useState} from 'react';
import 'datatables.net';
import 'datatables.net-responsive';
import {GET_COL_AGGREGATE_DATA, SEARCH_COLLECTION_URL} from '../../../api';
import $ from "jquery";
import {capitalize} from "../../../utils/capitalize";
import cogoToast from "cogo-toast";
import {
    aiPreview,
    assignment, assignmentDetail,
    assignmentReport,
    getPreSignedUrl,
    uploadPhoto
} from "../../../api/app";
import {useSelector} from "react-redux";
import 'select2';
import {truncate} from "../../../utils/trunate";
import {formatCount} from "../../../utils/generateChar";
import Modal from "bootstrap/js/dist/modal";
import "bootstrap/js/dist/dropdown";
import Offcanvas from "bootstrap/js/dist/offcanvas";
import formatNumber from "../../../utils/formatNumber";
import moment from "moment";

let searchableFields = [
    { field: 'subject', isNumeric: false },
    { field: 'description', isNumeric: false }
]

const Assignment = () => {

    document.title = "Assignment";

    const token = localStorage.getItem('jwtToken');

    const [stateReady, setStateReady] = useState(false);
    const auth = useSelector((state) => state.auth.user);
    const [reset, setReset] = useState(new Date().getTime());
    const searchQueryRef = useRef('');
    const searchTimeout = useRef(null);

    const handleSearch = (e) => {
        const value = e.target.value;
        clearTimeout(searchTimeout.current);
        searchTimeout.current = setTimeout(() => {
            searchQueryRef.current = value;
            reloadTable();
        }, 800);
    };

    useEffect(() => {
        assignmentReport().then((response) => {
            if(!response.error) {
                $('#total-engagement').text(formatCount(response.payload.total_engagement));
                $('#avg-engagement').text(`${formatCount(response.payload.avg_engagement_rate)}%`);
                $('#total-reach').text(formatCount(response.payload.total_reach));
                $('#total-followers').text(formatCount(response.payload.total_followers));
            }
        });
    }, [reset]);

    useEffect(() => {
        let table = $('#message_table').DataTable({
            dom: 'tip',
            responsive: true,
            language: {
                searchPlaceholder: 'Search name',
                sSearch: '',
                lengthMenu: '_MENU_ items/page',
                processing: '<div class="spinner-border"></div><p class="mg-t-10 tx-12">Collecting Assignment Data</p>'
            },
            searching: false,
            lengthMenu: [[10], [10]],
            ordering: false,
            info: true,
            bFilter: false,
            processing: true,
            pageLength: 10,
            serverSide: true,
            ajax: (data, callback) => {
                $.ajax(GET_COL_AGGREGATE_DATA, {
                    type: 'POST',
                    headers: {
                        "Authorization": token
                    },
                    contentType: 'application/json',
                    data: JSON.stringify({
                        query: searchQueryRef.current,
                        collection: "assignments",
                        filter: [
                            {
                                $match: {
                                    ...(auth.user.role === 'admin' ? {} : { admin: auth.user.sub }),
                                    ...(searchQueryRef.current ? {
                                        $or: searchableFields.map(({ field, isNumeric }) => ({
                                            [field]: isNumeric
                                                ? Number(searchQueryRef.current)
                                                : { $regex: searchQueryRef.current, $options: "i" }
                                        }))
                                    } : {})
                                }
                            },
                            {
                                $lookup: {
                                    from: "tasks",
                                    let: { assignmentId: "$_id" },
                                    pipeline: [
                                        {
                                            $match: {
                                                $expr: { $eq: ["$assignment", "$$assignmentId"] }
                                            }
                                        },
                                        {
                                            $group: {
                                                _id: null,
                                                count: { $sum: 1 },
                                                total_likes: { $sum: { $ifNull: ["$meta.facebook.likes", 0] } },
                                                total_comments: { $sum: { $ifNull: ["$meta.facebook.comments", 0] } },
                                                total_reach: { $sum: { $ifNull: ["$meta.facebook.reach", 0] } },
                                                total_awaiting: {
                                                    $sum: { $cond: [{ $eq: ["$status", "awaiting"] }, 1, 0] }
                                                }
                                            }
                                        }
                                    ],
                                    as: "tasks"
                                }
                            },
                            {
                                $addFields: {
                                    tasks_count: { $ifNull: [{ $arrayElemAt: ["$tasks.count", 0] }, 0] },
                                    total_likes: { $ifNull: [{ $arrayElemAt: ["$tasks.total_likes", 0] }, 0] },
                                    total_comments: { $ifNull: [{ $arrayElemAt: ["$tasks.total_comments", 0] }, 0] },
                                    total_reach: { $ifNull: [{ $arrayElemAt: ["$tasks.total_reach", 0] }, 0] },
                                    total_tasks: { $ifNull: [{ $arrayElemAt: ["$tasks.total_awaiting", 0] }, 0] }
                                }
                            },
                            {
                                $project: {
                                    subject: 1,
                                    description: 1,
                                    status: 1,
                                    type: 1,
                                    social: 1,
                                    admin: 1,
                                    date: 1,
                                    meta: 1,
                                    tasks_count: 1,
                                    total_likes: 1,
                                    total_comments: 1,
                                    total_reach: 1,
                                    total_tasks: 1
                                }
                            },
                            {
                                $sort: { _id: -1 } // optional
                            },
                            {
                                $facet: {
                                    results: [
                                        { $skip: data.start },
                                        { $limit: data.length }
                                    ],
                                    totalCount: [
                                        { $count: "total" }
                                    ]
                                }
                            }
                        ]
                    }),
                    success : function(res) {
                        let array = [];
                        res.data[0].results.map((data) => {
                            array.push({raw: data})
                        });

                        callback({
                            recordsTotal: res.data[0].totalCount[0] ? res.data[0].totalCount[0].total : 0,
                            recordsFiltered: res.data[0].totalCount[0] ? res.data[0].totalCount[0].total : 0,
                            data: array
                        });
                    },
                    error: function(err) {
                        cogoToast.error( err.responseJSON['error'].details !== undefined ? err.responseJSON['error'].details[0].message : err.responseJSON['error'], {position: "top-right", hideAfter: 5});
                    }
                });
            },
            "columns": [
                { "data": "raw" },
                { "data": "raw", "className": "align-middle" },
                { "data": "raw", "className": "align-middle" },
                { "data": "raw", "className": "align-middle" },
                { "data": "raw", "className": "align-middle" }
            ],
            "columnDefs": [
                {
                    "render": function (data) {
                        return `<div>
                                    <span class="text-capitalize tx-primary" style="color: black">${data.subject}</span>
                                    <p class="tx-secondary" style="color: #9893AE">${truncate(data.description, 200)}</p>
                                    <div class="d-flex align-items-center">
                                        <span style="margin-right: 16px"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M4.98633 12.2333L7.05299 13.8333C7.31966 14.1 7.91966 14.2333 8.31966 14.2333H10.853C11.653 14.2333 12.5197 13.6333 12.7197 12.8333L14.3197 7.96667C14.653 7.03333 14.053 6.23333 13.053 6.23333H10.3863C9.98633 6.23333 9.65299 5.9 9.71966 5.43333L10.053 3.3C10.1863 2.7 9.78633 2.03333 9.18633 1.83333C8.65299 1.63333 7.98633 1.9 7.71966 2.3L4.98633 6.36667" stroke="#9893AE" stroke-width="1.5" stroke-miterlimit="10"/>
                                            <path d="M1.58789 12.2333V5.70002C1.58789 4.76668 1.98789 4.43335 2.92122 4.43335H3.58789C4.52122 4.43335 4.92122 4.76668 4.92122 5.70002V12.2333C4.92122 13.1667 4.52122 13.5 3.58789 13.5H2.92122C1.98789 13.5 1.58789 13.1667 1.58789 12.2333Z" stroke="#9893AE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                            ${formatCount(data.total_likes)}
                                        </span>
                                    
                                        <span style="margin-right: 16px"><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M10.6775 11.7409C9.62558 12.5569 8.33217 12.9998 7.00089 13C5.8642 13.0017 4.75061 12.6791 3.79089 12.07L1.0009 13L1.93089 10.21C1.21866 9.08528 0.900716 7.75561 1.02711 6.43035C1.15351 5.10509 1.71706 3.8595 2.62906 2.88968C3.54106 1.91985 4.7497 1.28088 6.0647 1.07336C7.3797 0.865832 8.72637 1.10154 9.89271 1.74337C11.0591 2.3852 11.9788 3.3967 12.5072 4.61863C13.0356 5.84056 13.1426 7.20352 12.8113 8.49293C12.4801 9.78233 11.7294 10.925 10.6775 11.7409Z" stroke="#9893AE" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                            ${formatCount(data.total_comments)}
                                        </span>
                                    
                                        <span><svg width="18" height="14" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M0.75 5C0.75 5 2.75 0.75 7 0.75C11.25 0.75 13.25 5 13.25 5C13.25 5 11.25 9.25 7 9.25C2.75 9.25 0.75 5 0.75 5Z" stroke="#9893AE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M7 6.25C7.69036 6.25 8.25 5.69036 8.25 5C8.25 4.30964 7.69036 3.75 7 3.75C6.30964 3.75 5.75 4.30964 5.75 5C5.75 5.69036 6.30964 6.25 7 6.25Z" fill="#9893AE" stroke="#9893AE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                            ${formatCount(data.total_reach)}
                                        </span>
                                    </div>
                                </div>`;
                    },
                    "targets": 0
                },
                {
                    "render": function (data) {
                        return {
                            pending : `<span class="badge bg-progress text-black">${data.total_tasks}/${data.tasks_count} posted <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.5 12.5H9.16667V7.5H7.5V12.5ZM8.9275 5.59417C9.08695 5.43417 9.16667 5.23611 9.16667 5C9.16667 4.76389 9.08667 4.56611 8.92667 4.40667C8.76667 4.24722 8.56889 4.16722 8.33333 4.16667C8.09778 4.16611 7.9 4.24611 7.74 4.40667C7.58 4.56722 7.5 4.765 7.5 5C7.5 5.235 7.58 5.43306 7.74 5.59417C7.9 5.75528 8.09778 5.835 8.33333 5.83333C8.56889 5.83167 8.76694 5.75167 8.9275 5.59333M8.33333 16.6667C7.18056 16.6667 6.09722 16.4478 5.08333 16.01C4.06945 15.5722 3.1875 14.9786 2.4375 14.2292C1.6875 13.4797 1.09389 12.5978 0.656668 11.5833C0.219446 10.5689 0.00055661 9.48556 1.05485e-06 8.33333C-0.000554501 7.18111 0.218334 6.09778 0.656668 5.08333C1.095 4.06889 1.68861 3.18694 2.4375 2.4375C3.18639 1.68806 4.06833 1.09444 5.08333 0.656667C6.09833 0.218889 7.18167 0 8.33333 0C9.485 0 10.5683 0.218889 11.5833 0.656667C12.5983 1.09444 13.4803 1.68806 14.2292 2.4375C14.9781 3.18694 15.5719 4.06889 16.0108 5.08333C16.4497 6.09778 16.6683 7.18111 16.6667 8.33333C16.665 9.48556 16.4461 10.5689 16.01 11.5833C15.5739 12.5978 14.9803 13.4797 14.2292 14.2292C13.4781 14.9786 12.5961 15.5725 11.5833 16.0108C10.5706 16.4492 9.48722 16.6678 8.33333 16.6667Z" fill="#755F02"/>
                            </svg>
                            </span>`,
                            success : `<span class="badge badge-success tx-white">Success</span>`
                        }[data.status];
                    },
                    "targets": 1
                },
                {
                    "render": function () {
                        return `<img src="assets/img/facebook-icon.png" height="36" alt="facebook-icon"/>`
                    },
                    "targets": 2
                },
                {
                    "render": function (data) {
                        return `<span class="text-black">${moment(data?.date?.iso).format('Do, MMM, YYYY')}</span>`
                    },
                    "targets": 3
                },
                {
                    "render": function (data) {
                        return `<div class="dropdown">
                                    <a href="javascript:void(0)" class="nav-link text-center" data-bs-toggle="dropdown">
                                    <svg width="4" height="18" viewBox="0 0 4 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1.29289 1.29289C1.48043 1.10536 1.73478 1 2 1C2.26522 1 2.51957 1.10536 2.70711 1.29289C2.89464 1.48043 3 1.73478 3 2C3 2.26522 2.89464 2.51957 2.70711 2.70711C2.51957 2.89464 2.26522 3 2 3C1.73478 3 1.48043 2.89464 1.29289 2.70711C1.10536 2.51957 1 2.26522 1 2C1 1.73478 1.10536 1.48043 1.29289 1.29289Z" stroke="#9893AE" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M1.29289 8.29289C1.48043 8.10536 1.73478 8 2 8C2.26522 8 2.51957 8.10536 2.70711 8.29289C2.89464 8.48043 3 8.73478 3 9C3 9.26522 2.89464 9.51957 2.70711 9.70711C2.51957 9.89464 2.26522 10 2 10C1.73478 10 1.48043 9.89464 1.29289 9.70711C1.10536 9.51957 1 9.26522 1 9C1 8.73478 1.10536 8.48043 1.29289 8.29289Z" stroke="#9893AE" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path d="M1.29289 15.2929C1.48043 15.1054 1.73478 15 2 15C2.26522 15 2.51957 15.1054 2.70711 15.2929C2.89464 15.4804 3 15.7348 3 16C3 16.2652 2.89464 16.5196 2.70711 16.7071C2.51957 16.8946 2.26522 17 2 17C1.73478 17 1.48043 16.8946 1.29289 16.7071C1.10536 16.5196 0.999999 16.2652 0.999999 16C0.999999 15.7348 1.10536 15.4804 1.29289 15.2929Z" stroke="#9893AE" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                    </a>
                                      <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                        <li><a class="dropdown-item text-secondary" href="#/assignment/${data._id}"><i class="fa fa-bullseye-pointer"></i> Full Insight</a></li>
                                        <li><hr class="dropdown-divider"></li>
                                        <li><a class="dropdown-item text-secondary insight-report" href="#"><i class="fa fa-eye"></i> Quick Insight</a></li>
                                        <li><hr class="dropdown-divider"></li>
                                        <li><a class="dropdown-item text-danger delete_assignment" href="#"><i class="fa fa-trash"></i> Delete</a></li>
                                      </ul>
                                </div>`
                    },
                    "targets": 4
                }
            ]
        });

        table.on('click', '.delete_assignment', function(e) {
            e.preventDefault();
            let extract_td = table.row($(this).closest('tr')).data();

            $(".data-message").text(`Are you sure, you want to delete this assignment?`);
            $('#delete-data').unbind("click").click(function(){

                const modal = Modal.getInstance(document.getElementById("modalConfirm"));
                modal.hide();

                const options = {
                    position: "top-right",
                    hideAfter: 0
                };

                let {hide} = cogoToast.loading('Please wait... contacting to server.', options);

                let data = {
                    id: extract_td.raw._id,
                }

                assignment("delete", data).then((result) => {
                    hide();
                    if(!result.error) {
                        reloadTable();
                        cogoToast.success("Assignment successfully removed.", {position: "top-right"});
                    }
                });
            });

            const modal = Modal.getOrCreateInstance($('#modalConfirm')[0], {backdrop: 'static', focus: false});
            modal.show();
        });

        table.on('click', '.insight-report', function(e) {
            e.preventDefault();

            let extract_td = table.row($(this).closest('tr')).data();

            assignmentDetail(extract_td?.raw?._id).then((response) => {
                if(!response.error) {
                    const {total_reach, total_interactions, total_shares, total_engagement, total_comments, total_followers} = response.payload;

                    $("#total-view").text(formatNumber(total_reach));
                    $("#total-view-1").text(formatNumber(total_reach));
                    $("#total-interactions-1").text(formatNumber(total_interactions));
                    $("#total-interactions").text(formatNumber(total_interactions));
                    $("#total-shares").text(formatNumber(total_shares));
                    $("#total-comments-1").text(formatNumber(total_comments));
                    $("#total-engagements-1").text(formatNumber(total_engagement));
                    $("#total-followers").text(formatNumber(total_followers));

                    const offcanvas = Offcanvas.getOrCreateInstance($('#staticBackdrop')[0]);
                    offcanvas.show();
                }
            })
        })

        return () => {
            table.destroy();
        }

    }, []);

    const handleShowModal = () => {
        $('#assignment_form').parsley();
        $("#file").prop("disabled", true);
        $("#generate").prop("disabled", true);
        initialize();
        const modal = Modal.getOrCreateInstance($('#modalAssignment')[0], {backdrop: 'static', focus: false});
        modal.show();
    }

    const resetForm = (id, form) => {
        const parsley = $(`#${form}`).parsley();
        let button_check = $(".button-check");

        $(':input',`#${form}`)
            .not(':button, :submit, :reset, :hidden')
            .val('')
            .prop('checked', false)
            .prop('selected', false);
        const modal = Modal.getInstance(document.getElementById(id));
        modal.hide();
        parsley.reset();
        parsley.destroy();

        button_check.text("Submit");
        button_check.removeClass("btn-success");

        $(".modal-backdrop").remove();
    }

    const handleGenerateAssignment = async() => {

        let selection = $('#team-select2');
        let subject = $('#subject').val();
        let description = $('#description').val();
        let type = $('#type').val();
        let url = $('#url').val();
        let social = $('#social').val();
        let generate = $('#generate').is(':checked');
        let team = auth.user.role === "admin" ? selection.val() : [];
        let influencer = auth.user.role === "team" ? selection.val() : [];
        let fileInput = $('#file')[0];
        let file = fileInput?.files[0];

        setStateReady(true);

        let data = {
            subject,
            description,
            social,
            url,
            file_url: file && type === "post" ? await S3Upload(file, (data) => progress(data)) : null,
            type,
            team,
            influencer,
            generate
        }

        $("#modalAI").modal("hide");
        $("#modalAssignment").modal({ backdrop: 'static', focus: false, show: true });

        setTimeout(() => {
            assignment("post", data).then((result) => {
                setStateReady(false);
                if(!result.error) {
                    cogoToast.success("Assignment successfully created.", {position: "top-right", hideAfter: 5});
                    resetForm("modalAssignment", "assignment_form");
                    reloadTable();
                }
            });
        }, 1500);
    }

    const handleAssignmentSubmit = async(e) => {
        e.preventDefault();

        let selection = $('#team-select2');
        let subject = $('#subject').val();
        let description = $('#description').val();
        let type = $('#type').val();
        let url = $('#url').val();
        let social = $('#social').val();
        let team = auth.user.role === "admin" ? selection.val() : [];
        let influencer = auth.user.role === "team" ? selection.val() : [];
        let generate = $('#generate').is(':checked');
        let fileInput = $('#file')[0];
        let file = fileInput?.files[0];

        if(generate) {
            setStateReady(true);

            let data = {
                prompt: description
            }

            aiPreview("post", data).then((result) => {
                setStateReady(false);
                if(!result.error) {
                    setStateReady(false);
                    $("#ai-generated").text(result.payload);
                    $("#modalAssignment").modal("hide");
                    $("#modalAI").modal({ backdrop: 'static', focus: false, show: true });
                }
            });
        } else {
            setStateReady(true);
            let data = {
                subject,
                description,
                social,
                url,
                file_url: file && type === "post" ? await S3Upload(file, (data) => progress(data)) : null,
                type,
                team,
                influencer,
                generate
            }

            assignment("post", data).then((result) => {
                setStateReady(false);
                if(!result.error) {
                    cogoToast.success("Assignment successfully created.", {position: "top-right", hideAfter: 5});
                    resetForm("modalAssignment", "assignment_form");
                    reloadTable();
                }
            });
        }
    }

    const progress = (data) => {
        const btn = $("#progress-bar");
        btn.text(`Uploading ${data}%`);
    }

    const handleTypeChange = (e) => {
        let type = e.target.value;
        let url = $("#url");
        let file =  $("#file");
        let generate = $("#generate");

        if(type === "post") {
            file.prop("disabled", false);
            url.prop("required", false)
        } else {
            file.prop("disabled", true);
            url.prop("required", true)
        }

        if(type === "post" || type === "comment") {
            generate.prop("disabled", false);
        } else {
            generate.prop("disabled", true);
        }
    }

    const S3Upload = (file, onProgress) => {
        return getPreSignedUrl().then(async (response) => {
            if (response.error) return false;

            const headers = {};
            const mimeToExt = {
                "image/jpeg": "jpg",
                "image/png": "png",
                "video/mp4": "mp4"
            };

            const ext = mimeToExt[file.type] ? `.${mimeToExt[file.type]}` : "";
            const buffer = await file.arrayBuffer();

            return uploadPhoto(
                response.payload.url,
                buffer,
                headers,
                onProgress
            ).then((result) => {
                if (result.error) return null;
                const uploadUrl = result.payload.url;
                const cleanUrl = uploadUrl.split("?")[0];
                const { pathname } = new URL(cleanUrl);
                const filename = pathname.split("/").pop();
                return `https://s3.contentrelay.social/uploads/${filename}${ext}`;
            });
        });
    };

    const handleSocialChange = (e) => {
        let data = e.target.value;
        let url = $("#url");
        let generate = $("#generate");

        const type = $("#type").val();

        if(type === "post") return url.prop("required", false);

        if(data === "radio") {
            url.prop("required", false)
            generate.prop("disabled", true);
        } else {
            url.prop("required", true)
            generate.prop("disabled", false);
        }
    }

    const initialize = () => {
        let modalProduct = $('#modalAssignment');
        $('#team-select2').select2({
            placeholder: 'Select team/influencer',
            allowClear: true,
            width:"100%",
            dropdownParent: modalProduct,
            ajax: {
                url: SEARCH_COLLECTION_URL,
                dataType: 'json',
                type: "POST",
                headers: {
                    "Authorization": token
                },
                data: function(query) {
                    return {
                        query: query,
                        filter: auth.user.role === "admin" ? {} : {admin: auth.user.sub},
                        collection: auth.user.role === "admin" ? "admin" : "user"
                    };
                },
                processResults: function(data) {
                    return {
                        results: $.map(data, function(item) {
                            return {
                                text: capitalize(item.name),
                                id: item._id
                            }
                        })
                    };
                }
            }
        }).on('select2:select', function(e){
            $(".select2-search__field").css({display: "none"});
        }).on('select2:unselect', function(e) {
            $(".select2-search__field").css({display: "inline-block"});
        });
    }

    const reloadTable = () => {
        setReset(new Date().getTime());
        $('#message_table').DataTable().ajax.reload(null, false);
    };

    return (
        <div className="content-body">
            <div className="d-flex justify-content-between">
                <div>
                    <h2>Assignments</h2>
                    <h5>Monitoring your global digital presence across all platforms.</h5>
                </div>
                <div>
                    <a href="javascript:void(0)" className="btn btn-primary btn-create" onClick={handleShowModal.bind()}>
                        <svg className="me-2" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9.75 0C4.374 0 0 4.374 0 9.75C0 15.126 4.374 19.5 9.75 19.5C15.126 19.5 19.5 15.126 19.5 9.75C19.5 4.374 15.126 0 9.75 0ZM9.75 1.5C14.3153 1.5 18 5.18475 18 9.75C18 14.3153 14.3153 18 9.75 18C5.18475 18 1.5 14.3153 1.5 9.75C1.5 5.18475 5.18475 1.5 9.75 1.5ZM9 5.25V9H5.25V10.5H9V14.25H10.5V10.5H14.25V9H10.5V5.25H9Z" fill="#FFFFFF"/>
                        </svg>
                        Create Assignment
                    </a>
                </div>
            </div>

            <div className="row mt-4">
                <div className="col-md-3">
                    <div className="card card-view p-3">
                        <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="50" height="50" rx="25" fill="#F7F5FF"/>
                            <path d="M21.5143 17.17C21.5937 17.0423 21.7164 16.9476 21.86 16.903C22.0035 16.8585 22.1583 16.8672 22.296 16.9275C24.526 17.9025 25.6143 19.8425 26.1443 21.4617C26.2968 21.93 26.406 22.3783 26.4835 22.7783L26.5668 22.6783C27.2702 21.8483 28.3418 20.84 29.7977 20.1808C29.8771 20.1448 29.9632 20.1257 30.0504 20.1249C30.1376 20.1242 30.2241 20.1416 30.3041 20.1762C30.3842 20.2109 30.4561 20.2618 30.5153 20.3259C30.5744 20.39 30.6195 20.4658 30.6477 20.5483C30.7266 20.7806 30.8082 21.0175 30.8927 21.2592C31.2568 22.3025 31.6477 23.4233 31.876 24.5325C32.1593 25.9117 32.2135 27.3575 31.6343 28.7433C31.0914 30.0419 30.1765 31.1507 29.0048 31.9304C27.833 32.7101 26.4568 33.1257 25.0493 33.125C21.1102 33.125 17.916 29.9358 17.916 26C17.916 22.7717 18.996 21.0958 20.5993 18.61C20.8877 18.1608 21.1943 17.6858 21.5143 17.17ZM21.4577 25.8333C21.4577 25.6676 21.3918 25.5086 21.2746 25.3914C21.1574 25.2742 20.9984 25.2083 20.8327 25.2083C20.6669 25.2083 20.508 25.2742 20.3907 25.3914C20.2735 25.5086 20.2077 25.6676 20.2077 25.8333C20.2077 27.1042 20.7125 28.3229 21.6111 29.2216C22.5097 30.1202 23.7285 30.625 24.9993 30.625C25.1651 30.625 25.3241 30.5592 25.4413 30.4419C25.5585 30.3247 25.6243 30.1658 25.6243 30C25.6243 29.8342 25.5585 29.6753 25.4413 29.5581C25.3241 29.4409 25.1651 29.375 24.9993 29.375C24.06 29.375 23.1592 29.0019 22.495 28.3377C21.8308 27.6735 21.4577 26.7726 21.4577 25.8333Z" fill="#5D3EF4"/>
                        </svg>
                        <h6 className="mt-4" style={{fontSize: 14}}>Overall Engagement (2 platforms)</h6>
                        <h1 id="total-engagement">0</h1>
                        <span>Impressions, Reactions</span>
                    </div>
                </div>

                <div className="col-md-3">
                    <div className="card card-view p-3">
                        <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="50" height="50" rx="25" fill="#F7F5FF"/>
                            <path d="M21.2493 18.3333C18.7181 18.3333 16.666 20.3854 16.666 22.9167C16.666 27.5 22.0827 31.6667 24.9993 32.6358C27.916 31.6667 33.3327 27.5 33.3327 22.9167C33.3327 20.3854 31.2806 18.3333 28.7493 18.3333C27.1993 18.3333 25.8285 19.1029 24.9993 20.2808C24.5766 19.6789 24.0152 19.1877 23.3624 18.8487C22.7097 18.5097 21.9849 18.3329 21.2493 18.3333Z" fill="#5D3EF4" stroke="#5D3EF4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        <h6 className="mt-4" style={{fontSize: 14}}>Average Engagement Rate</h6>
                        <h1 id="avg-engagement">0%</h1>
                        <span>Facebook, TikTok</span>
                    </div>
                </div>

                <div className="col-md-3">
                    <div className="card card-view p-3">
                        <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="50" height="50" rx="25" fill="#F7F5FF"/>
                            <path d="M25.0129 17C24.4598 17 24.0129 17.4469 24.0129 18V19H19.0129C18.4598 19 18.0129 19.4469 18.0129 20V22C18.0129 22.5531 18.4598 23 19.0129 23H24.0129V25H19.2191C19.0879 25 18.9598 25.0531 18.866 25.1469L17.366 26.6469C17.1723 26.8406 17.1723 27.1594 17.366 27.3531L18.866 28.8531C18.9598 28.9469 19.0879 29 19.2191 29H24.0129V32C24.0129 32.5531 24.4598 33 25.0129 33C25.566 33 26.0129 32.5531 26.0129 32V29H31.0129C31.566 29 32.0129 28.5531 32.0129 28V26C32.0129 25.4469 31.566 25 31.0129 25H26.0129V23H30.8066C30.9379 23 31.066 22.9469 31.1598 22.8531L32.6598 21.3531C32.8535 21.1594 32.8535 20.8406 32.6598 20.6469L31.1598 19.1469C31.066 19.0531 30.9379 19 30.8066 19H26.0129V18C26.0129 17.4469 25.566 17 25.0129 17Z" fill="#5D3EF4"/>
                        </svg>
                        <h6 className="mt-4" style={{fontSize: 14}}>Post Reach</h6>
                        <h1 id="total-reach">0</h1>
                        <span>Facebook, TikTok</span>
                    </div>
                </div>

                <div className="col-md-3">
                    <div className="card card-view p-3">
                        <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="50" height="50" rx="25" fill="#F7F5FF"/>
                            <path d="M29.375 23.75C30.8668 23.75 32.2976 24.3426 33.3525 25.3975C34.4074 26.4524 35 27.8832 35 29.375C35 30.8668 34.4074 32.2976 33.3525 33.3525C32.2976 34.4074 30.8668 35 29.375 35C27.8832 35 26.4524 34.4074 25.3975 33.3525C24.3426 32.2976 23.75 30.8668 23.75 29.375C23.75 27.8832 24.3426 26.4524 25.3975 25.3975C26.4524 24.3426 27.8832 23.75 29.375 23.75ZM29.97 26.075C29.9339 25.9449 29.8562 25.8303 29.7487 25.7486C29.6412 25.6669 29.51 25.6227 29.375 25.6227C29.24 25.6227 29.1088 25.6669 29.0013 25.7486C28.8938 25.8303 28.8161 25.9449 28.78 26.075L28.1838 27.9912H26.2525C25.6462 27.9912 25.3938 28.7988 25.8837 29.17L27.4462 30.3538L26.8488 32.2687C26.6613 32.8687 27.3225 33.3687 27.8125 32.9975L29.375 31.8138L30.9375 32.9975C31.4275 33.3687 32.0875 32.8687 31.9 32.2687L31.3038 30.3538L32.8663 29.17C33.3563 28.7988 33.1038 27.9912 32.4975 27.9912H30.5662L29.97 26.075ZM24.0725 25C23.0544 26.2304 22.4981 27.7779 22.5 29.375C22.5 29.9812 22.5775 30.5688 22.725 31.1275C22.2377 31.2099 21.7442 31.2509 21.25 31.25C19.7812 31.25 18.4125 30.91 17.3888 30.2875C16.3638 29.6625 15.625 28.7063 15.625 27.5C15.625 26.837 15.8884 26.2011 16.3572 25.7322C16.8261 25.2634 17.462 25 18.125 25H24.0725ZM21.25 16.875C22.1617 16.875 23.036 17.2372 23.6807 17.8818C24.3253 18.5265 24.6875 19.4008 24.6875 20.3125C24.6875 21.2242 24.3253 22.0985 23.6807 22.7432C23.036 23.3878 22.1617 23.75 21.25 23.75C20.3383 23.75 19.464 23.3878 18.8193 22.7432C18.1747 22.0985 17.8125 21.2242 17.8125 20.3125C17.8125 19.4008 18.1747 18.5265 18.8193 17.8818C19.464 17.2372 20.3383 16.875 21.25 16.875ZM29.3775 18.1212C29.7472 18.1209 30.1133 18.1935 30.4549 18.3347C30.7965 18.476 31.1068 18.6832 31.3683 18.9446C31.6297 19.2059 31.8371 19.5162 31.9785 19.8577C32.12 20.1993 32.1927 20.5653 32.1925 20.935C32.1923 21.6335 31.9311 22.3067 31.46 22.8225C30.7857 22.6084 30.0825 22.4996 29.375 22.5C28.668 22.4993 27.9652 22.6077 27.2913 22.8212C26.927 22.4172 26.6876 21.9163 26.602 21.3791C26.5164 20.8419 26.5883 20.2914 26.809 19.7942C27.0297 19.297 27.3898 18.8744 27.8456 18.5775C28.3014 18.2806 28.8335 18.1221 29.3775 18.1212Z" fill="#5D3EF4"/>
                        </svg>
                        <h6 className="mt-4" style={{fontSize: 14}}>Overall Followers</h6>
                        <h1 id="total-followers">0</h1>
                        <span>Facebook, TikTok</span>
                    </div>
                </div>
            </div>

            <div className="card card-view mt-3">
                <div className="p-3 d-flex justify-content-between align-items-end">
                    <h4 style={{fontSize: 20}}>Recent Post Assignments</h4>
                    <div className="position-relative" style={{ width: "20%" }}>
                        <svg style={{position: "absolute", left: "12px", top: "54%", transform: "translateY(-50%)", pointerEvents: "none"}} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.7832 14.3911L20 18.6069L18.6069 20L14.3911 15.7832C12.8224 17.0407 10.8713 17.7246 8.86088 17.7218C3.96968 17.7218 0 13.7521 0 8.86088C0 3.96968 3.96968 0 8.86088 0C13.7521 0 17.7218 3.96968 17.7218 8.86088C17.7246 10.8713 17.0407 12.8224 15.7832 14.3911ZM13.8082 13.6605C15.0574 12.3754 15.7552 10.6531 15.7527 8.86088C15.7527 5.05366 12.6681 1.96909 8.86088 1.96909C5.05366 1.96909 1.96909 5.05366 1.96909 8.86088C1.96909 12.6681 5.05366 15.7527 8.86088 15.7527C10.6531 15.7552 12.3754 15.0574 13.6605 13.8082L13.8082 13.6605Z" fill="#9893AE"/>
                        </svg>
                        <input type="text" className="form-control" placeholder="Search assignment..." style={{ paddingLeft: "40px" }} onChange={handleSearch}/>
                    </div>
                </div>
                <div className="card-body table-responsive p-0">
                    <table id="message_table" className="table" style={{width: "100%"}}>
                        <thead>
                        <tr>
                            <th style={{width: "60%"}}>Post Content</th>
                            <th style={{width: "10%"}}>Status</th>
                            <th style={{width: "10%"}}>Platform</th>
                            <th style={{width: "10%"}}>Date</th>
                            <th style={{width: "10%"}}>Actions</th>
                        </tr>
                        </thead>
                    </table>
                </div>
            </div>

            <div className="modal fade" id="modalAssignment" tabIndex="-1" role="dialog" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header border-0 pb-0">
                            <div>
                                <h5 className="modal-title fw-bold">Create Assignment</h5>
                                <p className="text-muted mb-0" style={{fontSize: 13}}>Send task assignment to end users</p>
                            </div>
                            <a href="javascript:void(0)" role="button" data-dismiss="modal" onClick={resetForm.bind(null, "modalAssignment", "assignment_form")} aria-label="Close">
                                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="32" height="32" rx="16" fill="black"/>
                                    <path fillRule="evenodd" clipRule="evenodd" d="M12.5272 12.5287C12.6522 12.4037 12.8218 12.3335 12.9986 12.3335C13.1753 12.3335 13.3449 12.4037 13.4699 12.5287L15.9986 15.0573L18.5272 12.5287C18.5887 12.465 18.6623 12.4142 18.7436 12.3793C18.825 12.3443 18.9124 12.3259 19.001 12.3252C19.0895 12.3244 19.1773 12.3413 19.2592 12.3748C19.3411 12.4083 19.4156 12.4578 19.4782 12.5204C19.5407 12.583 19.5902 12.6574 19.6238 12.7394C19.6573 12.8213 19.6742 12.9091 19.6734 12.9976C19.6726 13.0861 19.6542 13.1736 19.6193 13.2549C19.5843 13.3363 19.5336 13.4098 19.4699 13.4713L16.9412 16L19.4699 18.5287C19.5913 18.6544 19.6585 18.8228 19.657 18.9976C19.6555 19.1724 19.5854 19.3396 19.4618 19.4632C19.3382 19.5868 19.171 19.6569 18.9962 19.6585C18.8214 19.66 18.653 19.5928 18.5272 19.4713L15.9986 16.9427L13.4699 19.4713C13.3442 19.5928 13.1758 19.66 13.001 19.6585C12.8262 19.6569 12.6589 19.5868 12.5353 19.4632C12.4117 19.3396 12.3416 19.1724 12.3401 18.9976C12.3386 18.8228 12.4058 18.6544 12.5272 18.5287L15.0559 16L12.5272 13.4713C12.4022 13.3463 12.332 13.1768 12.332 13C12.332 12.8232 12.4022 12.6537 12.5272 12.5287Z" fill="white"/>
                                </svg>
                            </a>
                        </div>

                        <div className="modal-body pt-3">
                            <form id="assignment_form" className="parsley-style-1" onSubmit={handleAssignmentSubmit.bind()}>

                                <div id="subjectWrapper" className="form-group parsley-input mb-3">
                                    <label className="form-label">Title <span className="text-danger">*</span></label>
                                    <input id="subject" type="text" className="form-control"
                                           placeholder="Enter assignment title"
                                           autoComplete="off"
                                           data-parsley-class-handler="#subjectWrapper" required/>
                                </div>

                                <div className="row mb-3">
                                    <div className="col-md-6">
                                        <div id="typeWrapper" className="form-group parsley-input">
                                            <label className="form-label">Type <span className="text-danger">*</span></label>
                                            <div className="parsley-select">
                                                <select className="form-control form-select"
                                                        id="type"
                                                        data-parsley-class-handler="#typeWrapper"
                                                        data-parsley-errors-container="#typeWrapper"
                                                        required
                                                        onChange={handleTypeChange.bind()
                                                        }>
                                                    <option value="" disabled defaultValue="" selected>Select Type</option>
                                                    <option value="post">Post</option>
                                                    <option value="comment">Comment</option>
                                                    <option value="report">Report</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div id="socialWrapper" className="form-group parsley-input">
                                            <label className="form-label">Social <span className="text-danger">*</span></label>
                                            <div className="parsley-select">
                                                <select className="form-control form-select" id="social"
                                                        data-parsley-class-handler="#socialWrapper"
                                                        data-parsley-errors-container="#socialWrapper"
                                                        required
                                                        onChange={handleSocialChange.bind()}>
                                                    <option value="" disabled defaultValue="" selected>Select Social</option>
                                                    <option value="facebook">Facebook</option>
                                                    {/*<option value="tiktok">TikTok</option>*/}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div id="urlWrapper" className="form-group parsley-input mb-3">
                                    <label className="form-label">Post URL or Link</label>
                                    <input id="url" type="text" className="form-control"
                                           placeholder="https://"
                                           autoComplete="off"
                                           data-parsley-class-handler="#urlWrapper"/>
                                </div>

                                <div id="fileWrapper" className="form-group parsley-input mb-3">
                                    <label className="form-label">File Upload <span className="text-muted" style={{fontSize: 12}}>(Optional)</span></label>
                                    <input id="file" type="file" className="form-control"
                                           data-parsley-filemaxmegabytes="100"
                                           data-parsley-trigger="change"
                                           data-parsley-filemimetypes="image/jpeg, image/jpg, image/png, video/mp4"
                                           accept="image/jpeg, image/jpg, image/png, video/mp4"
                                           data-parsley-class-handler="#fileWrapper"
                                    />
                                    <div className="form-text">Supported: JPG, PNG, MP4 — max 10MB</div>
                                </div>

                                {auth.user.role === "admin" ? (
                                    <div id="teamWrapper" className="form-group parsley-input mb-3">
                                        <label className="form-label">Team <span style={{fontSize: 12}}>(Optional)</span></label>
                                        <select className="form-control form-select" id="team-select2" data-width="100%"
                                                multiple="multiple"
                                                data-parsley-class-handler="#teamWrapper"
                                                data-parsley-errors-container="#teamWrapper"
                                                autoComplete="off"
                                        />
                                    </div>
                                ) : <div id="teamWrapper1" className="form-group parsley-input mb-3">
                                    <label className="form-label">Influencer <span style={{fontSize: 12}}>(Optional)</span></label>
                                    <select className="form-control form-select" id="team-select2" data-width="100%"
                                            multiple="multiple"
                                            data-parsley-class-handler="#teamWrapper1"
                                            data-parsley-errors-container="#teamWrapper1"
                                            autoComplete="off"
                                    />
                                </div>}

                                {/* Task / Description */}
                                <div id="messageWrapper" className="form-group parsley-input mb-3">
                                    <div className="d-flex justify-content-between align-items-center mb-1">
                                        <label className="form-label mb-0">Task <span className="text-danger">*</span></label>
                                        <div className="form-check form-switch mb-0">
                                            <input className="form-check-input" type="checkbox" role="switch"
                                                   name="_form[]" id="generate"
                                                   onClick={(e) => {
                                                       let button_check = $(".button-check");
                                                       if (e.target.checked) {
                                                           button_check.text("AI Preview");
                                                           button_check.addClass("btn-success");
                                                       } else {
                                                           button_check.text("Submit");
                                                           button_check.removeClass("btn-success");
                                                       }
                                                   }}/>
                                            <label className="form-check-label" htmlFor="generate" style={{fontSize: 13}}>
                                                AI Generate
                                            </label>
                                        </div>
                                    </div>
                                    <textarea id="description" className="form-control" rows="6"
                                              data-parsley-class-handler="#messageWrapper"
                                              data-parsley-validation-threshold="10"
                                              placeholder="Describe the task..."
                                              required/>
                                </div>

                                {/* Submit */}
                                <div className="d-grid">
                                    {stateReady
                                        ? <button disabled className="btn btn-primary">
                                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"/>
                                            <span id="progress-bar">Please Wait</span>
                                        </button>
                                        : <button className="btn btn-primary button-check">Submit</button>
                                    }
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="modalAI" tabIndex="-1" role="dialog" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header border-0 pb-0">
                            <div>
                                <h5 className="modal-title fw-bold">AI Generated</h5>
                                <p className="text-muted mb-0" style={{fontSize: 13}}>Send task assignment to end users</p>
                            </div>
                            <a href="#" role="button" className="close pos-absolute t-15 r-15" data-dismiss="modal" onClick={() => {
                                $("#modalAI").modal("hide");
                                let button_check = $(".button-check");
                                button_check.text("AI Preview");
                                button_check.addClass("btn-success");
                                $("#modalAssignment").modal({ backdrop: 'static', focus: false, show: true });
                            }} aria-label="Close"><svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect width="32" height="32" rx="16" fill="black"/>
                                <path fillRule="evenodd" clipRule="evenodd" d="M12.5272 12.5287C12.6522 12.4037 12.8218 12.3335 12.9986 12.3335C13.1753 12.3335 13.3449 12.4037 13.4699 12.5287L15.9986 15.0573L18.5272 12.5287C18.5887 12.465 18.6623 12.4142 18.7436 12.3793C18.825 12.3443 18.9124 12.3259 19.001 12.3252C19.0895 12.3244 19.1773 12.3413 19.2592 12.3748C19.3411 12.4083 19.4156 12.4578 19.4782 12.5204C19.5407 12.583 19.5902 12.6574 19.6238 12.7394C19.6573 12.8213 19.6742 12.9091 19.6734 12.9976C19.6726 13.0861 19.6542 13.1736 19.6193 13.2549C19.5843 13.3363 19.5336 13.4098 19.4699 13.4713L16.9412 16L19.4699 18.5287C19.5913 18.6544 19.6585 18.8228 19.657 18.9976C19.6555 19.1724 19.5854 19.3396 19.4618 19.4632C19.3382 19.5868 19.171 19.6569 18.9962 19.6585C18.8214 19.66 18.653 19.5928 18.5272 19.4713L15.9986 16.9427L13.4699 19.4713C13.3442 19.5928 13.1758 19.66 13.001 19.6585C12.8262 19.6569 12.6589 19.5868 12.5353 19.4632C12.4117 19.3396 12.3416 19.1724 12.3401 18.9976C12.3386 18.8228 12.4058 18.6544 12.5272 18.5287L15.0559 16L12.5272 13.4713C12.4022 13.3463 12.332 13.1768 12.332 13C12.332 12.8232 12.4022 12.6537 12.5272 12.5287Z" fill="white"/>
                            </svg></a>
                        </div>

                        <div className="modal-body pd-sm-t-30 pd-sm-b-40 pd-sm-x-30">
                            <p id="ai-generated">Nothing generated here...</p>
                            <button className="btn btn-primary btn-block mt-5" onClick={handleGenerateAssignment.bind()}>Confirm &amp; Proceed</button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="modalInsightReport" tabIndex="-1" role="dialog" aria-labelledby="confirmation" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header border-0 pb-0">
                            <div>
                                <h5 className="modal-title">Stats Report</h5>
                                <p className="text-muted mb-0" style={{fontSize: 13}}>Overview of your post performance</p>
                            </div>
                            <a href="#" role="button" data-dismiss="modal" aria-label="Close">
                                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="32" height="32" rx="16" fill="black"/>
                                    <path fillRule="evenodd" clipRule="evenodd" d="M12.5272 12.5287C12.6522 12.4037 12.8218 12.3335 12.9986 12.3335C13.1753 12.3335 13.3449 12.4037 13.4699 12.5287L15.9986 15.0573L18.5272 12.5287C18.5887 12.465 18.6623 12.4142 18.7436 12.3793C18.825 12.3443 18.9124 12.3259 19.001 12.3252C19.0895 12.3244 19.1773 12.3413 19.2592 12.3748C19.3411 12.4083 19.4156 12.4578 19.4782 12.5204C19.5407 12.583 19.5902 12.6574 19.6238 12.7394C19.6573 12.8213 19.6742 12.9091 19.6734 12.9976C19.6726 13.0861 19.6542 13.1736 19.6193 13.2549C19.5843 13.3363 19.5336 13.4098 19.4699 13.4713L16.9412 16L19.4699 18.5287C19.5913 18.6544 19.6585 18.8228 19.657 18.9976C19.6555 19.1724 19.5854 19.3396 19.4618 19.4632C19.3382 19.5868 19.171 19.6569 18.9962 19.6585C18.8214 19.66 18.653 19.5928 18.5272 19.4713L15.9986 16.9427L13.4699 19.4713C13.3442 19.5928 13.1758 19.66 13.001 19.6585C12.8262 19.6569 12.6589 19.5868 12.5353 19.4632C12.4117 19.3396 12.3416 19.1724 12.3401 18.9976C12.3386 18.8228 12.4058 18.6544 12.5272 18.5287L15.0559 16L12.5272 13.4713C12.4022 13.3463 12.332 13.1768 12.332 13C12.332 12.8232 12.4022 12.6537 12.5272 12.5287Z" fill="white"/>
                                </svg>
                            </a>
                        </div>

                        <div className="modal-body pt-3">

                            {/* Stats Cards */}
                            <div className="row g-3 mb-4">
                                <div className="col-6 col-lg-3">
                                    <div className="card card-view p-3" style={{backgroundColor: "#F7F5FF"}}>
                                        <div className="insight-icon-wrap bg-purple-light mb-2">
                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M7 22V11M2 13V20C2 21.1046 2.89543 22 4 22H17.4262C18.907 22 20.1662 20.9525 20.3914 19.4872L21.4914 12.4872C21.7688 10.671 20.3768 9 18.5404 9H15C14.4477 9 14 8.55228 14 8V4.46584C14 3.10399 12.896 2 11.5342 2C11.2093 2 10.9168 2.1913 10.7831 2.48812L7.26394 10.4061C7.10344 10.7673 6.74532 11 6.35013 11H4C2.89543 11 2 11.8954 2 13Z" stroke="#5D3EF4" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                            </svg>
                                        </div>
                                        <h3 id="total-likes" className="fw-bold mb-1" style={{fontSize: 28, color: 'black'}}>0</h3>
                                        <p style={{fontSize: 13, color: '#9893AE'}}>Likes</p>
                                    </div>
                                </div>
                                <div className="col-6 col-lg-3">
                                    <div className="card card-view p-3" style={{backgroundColor: "#F7F5FF"}}>
                                        <div className="insight-icon-wrap bg-blue-light mb-2">
                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M10.5 20H6C4.89543 20 4 19.1046 4 18V6C4 4.89543 4.89543 4 6 4H18C19.1046 4 20 4.89543 20 6V10.5M8 10H16M8 14H12M18 21V15M15 18H21" stroke="#00B4D8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                            </svg>
                                        </div>
                                        <h3 id="total-comments" className="fw-bold mb-1" style={{fontSize: 28, color: 'black'}}>0</h3>
                                        <p style={{fontSize: 13, color: '#9893AE'}}>Comments</p>
                                    </div>
                                </div>
                                <div className="col-6 col-lg-3">
                                    <div className="card card-view p-3" style={{backgroundColor: "#F7F5FF"}}>
                                        <div className="insight-icon-wrap bg-green-light mb-2">
                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M4 12V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V12M12 2V16M12 2L8 6M12 2L16 6" stroke="#7C9500" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                            </svg>
                                        </div>
                                        <h3 id="total-shares" className="fw-bold mb-1" style={{fontSize: 28, color: 'black'}}>0</h3>
                                        <p style={{fontSize: 13, color: '#9893AE'}}>Shares</p>
                                    </div>
                                </div>
                                <div className="col-6 col-lg-3">
                                    <div className="card card-view p-3" style={{backgroundColor: "#F7F5FF"}}>
                                        <div className="insight-icon-wrap bg-red-light mb-2">
                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" stroke="#ED1414" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                            </svg>
                                        </div>
                                        <h3 id="total-reactions" className="fw-bold mb-1" style={{fontSize: 28, color: 'black'}}>0</h3>
                                        <p style={{fontSize: 13, color: '#9893AE'}}>Reactions</p>
                                    </div>
                                </div>
                            </div>

                            {/* Engagement */}
                            <div className="card card-view p-3 mb-3">
                                <p style={{fontSize: 12, color: '#9893AE', textTransform: 'uppercase', letterSpacing: '0.08em'}}>Total Engagement</p>
                                <h2 id="total-engagements" style={{fontSize: 32, fontWeight: 700, color: 'black'}}>0</h2>
                            </div>

                            <hr/>

                            {/* Page Info */}
                            <div className="card card-view p-3">
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <p style={{fontSize: 12, color: '#9893AE', textTransform: 'uppercase', letterSpacing: '0.08em'}} className="mb-0">Page Info</p>
                                    <div className="d-flex gap-2">
                                        <a href="#" target="_blank" rel="noreferrer" id="post-link-1"
                                           className="d-flex align-items-center gap-1"
                                           style={{fontSize: 13, color: '#5D3EF4', fontWeight: 500}}>
                                            View Post
                                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M18 13V19C18 19.5304 17.7893 20.0391 17.4142 20.4142C17.0391 20.7893 16.5304 21 16 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V8C3 7.46957 3.21071 6.96086 3.58579 6.58579C3.96086 6.21071 4.46957 6 5 6H11M15 3H21M21 3V9M21 3L10 14" stroke="#5D3EF4" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                            </svg>
                                        </a>
                                        <span style={{color: '#EAE9F3'}}>|</span>
                                        <a href="#" target="_blank" rel="noreferrer" id="page-link-1"
                                           className="d-flex align-items-center gap-1"
                                           style={{fontSize: 13, color: '#5D3EF4', fontWeight: 500}}>
                                            View Page
                                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M18 13V19C18 19.5304 17.7893 20.0391 17.4142 20.4142C17.0391 20.7893 16.5304 21 16 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V8C3 7.46957 3.21071 6.96086 3.58579 6.58579C3.96086 6.21071 4.46957 6 5 6H11M15 3H21M21 3V9M21 3L10 14" stroke="#5D3EF4" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                            </svg>
                                        </a>
                                    </div>
                                </div>
                                <div className="d-flex justify-content-between align-items-center">
                                    <div className="d-flex align-items-center gap-3">
                                        <img id="page-logo-1" src="" alt="logo"
                                             style={{width: 48, height: 48, borderRadius: 12, objectFit: 'cover', background: '#F4F2FC'}}/>
                                        <div>
                                            <p id="page-name-1" className="fw-semibold mb-0" style={{fontSize: 15, color: 'black'}}>Name</p>
                                            <p id="page-category-1" style={{fontSize: 12, color: '#9893AE'}} className="mb-0">Category</p>
                                        </div>
                                    </div>
                                    <div className="text-end">
                                        <p style={{fontSize: 12, color: '#9893AE'}} className="mb-0">Followers</p>
                                        <p id="page-follower-1" className="fw-bold mb-0" style={{fontSize: 16, color: 'black'}}>0</p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <div className="offcanvas offcanvas-end" data-bs-backdrop="static" tabIndex="-1" id="staticBackdrop"
                 aria-labelledby="staticBackdropLabel">

                <div className="offcanvas-body" id="social-account">
                    <div className="mb-3">
                        <h5 className="modal-title">Overall Post Performance</h5>
                        <p className="text-muted mb-0" style={{fontSize: 13}}>Post performance is performing across platforms</p>
                    </div>

                    <div className="card card-view p-3 mt-2" style={{backgroundColor: "#F7F5FF"}}>
                        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect width="36" height="36" rx="18" fill="#E7E3F8"/>
                            <path d="M18 20.5C19.3807 20.5 20.5 19.3807 20.5 18C20.5 16.6193 19.3807 15.5 18 15.5C16.6193 15.5 15.5 16.6193 15.5 18C15.5 19.3807 16.6193 20.5 18 20.5Z" fill="#5D3EF4"/>
                            <path d="M27.3372 17.7875C26.6021 15.886 25.326 14.2416 23.6665 13.0576C22.007 11.8735 20.0369 11.2016 17.9997 11.125C15.9626 11.2016 13.9925 11.8735 12.333 13.0576C10.6735 14.2416 9.39733 15.886 8.66223 17.7875C8.61259 17.9248 8.61259 18.0752 8.66223 18.2125C9.39733 20.114 10.6735 21.7584 12.333 22.9424C13.9925 24.1265 15.9626 24.7984 17.9997 24.875C20.0369 24.7984 22.007 24.1265 23.6665 22.9424C25.326 21.7584 26.6021 20.114 27.3372 18.2125C27.3869 18.0752 27.3869 17.9248 27.3372 17.7875ZM17.9997 22.0625C17.1962 22.0625 16.4108 21.8242 15.7427 21.3778C15.0747 20.9315 14.554 20.297 14.2465 19.5547C13.939 18.8123 13.8585 17.9955 14.0153 17.2074C14.172 16.4194 14.559 15.6955 15.1271 15.1274C15.6953 14.5592 16.4191 14.1723 17.2072 14.0156C17.9952 13.8588 18.8121 13.9393 19.5544 14.2467C20.2967 14.5542 20.9312 15.0749 21.3776 15.743C21.824 16.4111 22.0622 17.1965 22.0622 18C22.0606 19.0769 21.632 20.1093 20.8705 20.8708C20.109 21.6323 19.0767 22.0608 17.9997 22.0625Z" fill="#5D3EF4"/>
                        </svg>

                        <h6 className="mt-2">Views</h6>
                        <h3 id="total-view">0</h3>
                    </div>

                    <div className="d-flex justify-content-between align-items-center">
                        <div className="card card-view p-3 mt-2" style={{backgroundColor: "#F7F5FF", width: "100%"}}>
                            <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect width="36" height="36" rx="18" fill="#E7E3F8"/>
                                <path d="M17.9993 26.3333C16.8466 26.3333 15.7632 26.1145 14.7494 25.6767C13.7355 25.2389 12.8535 24.6453 12.1035 23.8958C11.3535 23.1464 10.7599 22.2645 10.3227 21.25C9.88546 20.2356 9.66657 19.1522 9.66602 18C9.66546 16.8478 9.88435 15.7645 10.3227 14.75C10.761 13.7356 11.3546 12.8536 12.1035 12.1042C12.8524 11.3547 13.7344 10.7611 14.7494 10.3233C15.7644 9.88557 16.8477 9.66668 17.9993 9.66668C18.4716 9.66668 18.9299 9.7014 19.3743 9.77085C19.8188 9.84029 20.2563 9.9514 20.6868 10.1042C20.8813 10.1736 21.0377 10.2953 21.156 10.4692C21.2743 10.6431 21.3332 10.8339 21.3327 11.0417V12.2292C21.3327 12.6736 21.4891 13.0522 21.8018 13.365C22.1146 13.6778 22.493 13.8339 22.9368 13.8333H22.9994V14.3125C22.9994 14.632 23.1174 14.9097 23.3535 15.1458C23.5896 15.382 23.8674 15.5 24.1868 15.5H25.2494C25.4577 15.5 25.6452 15.5625 25.8118 15.6875C25.9785 15.8125 26.0896 15.9792 26.1452 16.1875C26.2146 16.4792 26.2632 16.7745 26.291 17.0733C26.3188 17.3722 26.3327 17.6811 26.3327 18C26.3327 19.1528 26.1138 20.2361 25.676 21.25C25.2382 22.2639 24.6446 23.1458 23.8952 23.8958C23.1457 24.6458 22.2638 25.2397 21.2493 25.6775C20.2349 26.1153 19.1516 26.3339 17.9993 26.3333ZM17.9993 22.5833C18.8049 22.5833 19.548 22.3889 20.2285 22C20.9091 21.6111 21.4577 21.0833 21.8743 20.4167C21.9577 20.25 21.9507 20.0833 21.8535 19.9167C21.7563 19.75 21.6105 19.6667 21.416 19.6667H14.5827C14.3882 19.6667 14.2424 19.75 14.1452 19.9167C14.048 20.0833 14.041 20.25 14.1244 20.4167C14.541 21.0833 15.0932 21.6111 15.781 22C16.4688 22.3889 17.2082 22.5833 17.9993 22.5833ZM15.0827 17.1667C15.4299 17.1667 15.7252 17.0453 15.9685 16.8025C16.2118 16.5597 16.3332 16.2645 16.3327 15.9167C16.3321 15.5689 16.2107 15.2739 15.9685 15.0317C15.7263 14.7895 15.431 14.6678 15.0827 14.6667C14.7344 14.6656 14.4394 14.7872 14.1977 15.0317C13.956 15.2761 13.8344 15.5711 13.8327 15.9167C13.831 16.2622 13.9527 16.5575 14.1977 16.8025C14.4427 17.0475 14.7377 17.1689 15.0827 17.1667ZM20.916 17.1667C21.2632 17.1667 21.5585 17.0453 21.8018 16.8025C22.0452 16.5597 22.1666 16.2645 22.166 15.9167C22.1655 15.5689 22.0441 15.2739 21.8018 15.0317C21.5596 14.7895 21.2643 14.6678 20.916 14.6667C20.5677 14.6656 20.2727 14.7872 20.031 15.0317C19.7893 15.2761 19.6677 15.5711 19.666 15.9167C19.6643 16.2622 19.786 16.5575 20.031 16.8025C20.276 17.0475 20.571 17.1689 20.916 17.1667ZM24.666 12.1667H23.8327C23.5966 12.1667 23.3988 12.0867 23.2394 11.9267C23.0799 11.7667 22.9999 11.5689 22.9994 11.3333C22.9988 11.0978 23.0788 10.9 23.2394 10.74C23.3999 10.58 23.5977 10.5 23.8327 10.5H24.666V9.66668C24.666 9.43057 24.746 9.23279 24.906 9.07335C25.066 8.9139 25.2638 8.8339 25.4994 8.83335C25.7349 8.83279 25.933 8.91279 26.0935 9.07335C26.2541 9.2339 26.3338 9.43168 26.3327 9.66668V10.5H27.166C27.4021 10.5 27.6002 10.58 27.7602 10.74C27.9202 10.9 27.9999 11.0978 27.9993 11.3333C27.9988 11.5689 27.9188 11.767 27.7593 11.9275C27.5999 12.0881 27.4021 12.1678 27.166 12.1667H26.3327V13C26.3327 13.2361 26.2527 13.4342 26.0927 13.5942C25.9327 13.7542 25.7349 13.8339 25.4994 13.8333C25.2638 13.8328 25.066 13.7528 24.906 13.5933C24.746 13.4339 24.666 13.2361 24.666 13V12.1667Z" fill="#5D3EF4"/>
                            </svg>
                            <h6 className="mt-2">Interactions</h6>
                            <h3 id="total-interactions">0</h3>
                        </div>
                        <div className="card card-view p-3 mt-2" style={{backgroundColor: "#F7F5FF", width: "100%"}}>
                            <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect width="36" height="36" rx="18" fill="#E7E3F8"/>
                                <path d="M17.9993 26.3333C16.8466 26.3333 15.7632 26.1145 14.7494 25.6767C13.7355 25.2389 12.8535 24.6453 12.1035 23.8958C11.3535 23.1464 10.7599 22.2645 10.3227 21.25C9.88546 20.2356 9.66657 19.1522 9.66602 18C9.66546 16.8478 9.88435 15.7645 10.3227 14.75C10.761 13.7356 11.3546 12.8536 12.1035 12.1042C12.8524 11.3547 13.7344 10.7611 14.7494 10.3233C15.7644 9.88557 16.8477 9.66668 17.9993 9.66668C18.4716 9.66668 18.9299 9.7014 19.3743 9.77085C19.8188 9.84029 20.2563 9.9514 20.6868 10.1042C20.8813 10.1736 21.0377 10.2953 21.156 10.4692C21.2743 10.6431 21.3332 10.8339 21.3327 11.0417V12.2292C21.3327 12.6736 21.4891 13.0522 21.8018 13.365C22.1146 13.6778 22.493 13.8339 22.9368 13.8333H22.9994V14.3125C22.9994 14.632 23.1174 14.9097 23.3535 15.1458C23.5896 15.382 23.8674 15.5 24.1868 15.5H25.2494C25.4577 15.5 25.6452 15.5625 25.8118 15.6875C25.9785 15.8125 26.0896 15.9792 26.1452 16.1875C26.2146 16.4792 26.2632 16.7745 26.291 17.0733C26.3188 17.3722 26.3327 17.6811 26.3327 18C26.3327 19.1528 26.1138 20.2361 25.676 21.25C25.2382 22.2639 24.6446 23.1458 23.8952 23.8958C23.1457 24.6458 22.2638 25.2397 21.2493 25.6775C20.2349 26.1153 19.1516 26.3339 17.9993 26.3333ZM17.9993 22.5833C18.8049 22.5833 19.548 22.3889 20.2285 22C20.9091 21.6111 21.4577 21.0833 21.8743 20.4167C21.9577 20.25 21.9507 20.0833 21.8535 19.9167C21.7563 19.75 21.6105 19.6667 21.416 19.6667H14.5827C14.3882 19.6667 14.2424 19.75 14.1452 19.9167C14.048 20.0833 14.041 20.25 14.1244 20.4167C14.541 21.0833 15.0932 21.6111 15.781 22C16.4688 22.3889 17.2082 22.5833 17.9993 22.5833ZM15.0827 17.1667C15.4299 17.1667 15.7252 17.0453 15.9685 16.8025C16.2118 16.5597 16.3332 16.2645 16.3327 15.9167C16.3321 15.5689 16.2107 15.2739 15.9685 15.0317C15.7263 14.7895 15.431 14.6678 15.0827 14.6667C14.7344 14.6656 14.4394 14.7872 14.1977 15.0317C13.956 15.2761 13.8344 15.5711 13.8327 15.9167C13.831 16.2622 13.9527 16.5575 14.1977 16.8025C14.4427 17.0475 14.7377 17.1689 15.0827 17.1667ZM20.916 17.1667C21.2632 17.1667 21.5585 17.0453 21.8018 16.8025C22.0452 16.5597 22.1666 16.2645 22.166 15.9167C22.1655 15.5689 22.0441 15.2739 21.8018 15.0317C21.5596 14.7895 21.2643 14.6678 20.916 14.6667C20.5677 14.6656 20.2727 14.7872 20.031 15.0317C19.7893 15.2761 19.6677 15.5711 19.666 15.9167C19.6643 16.2622 19.786 16.5575 20.031 16.8025C20.276 17.0475 20.571 17.1689 20.916 17.1667ZM24.666 12.1667H23.8327C23.5966 12.1667 23.3988 12.0867 23.2394 11.9267C23.0799 11.7667 22.9999 11.5689 22.9994 11.3333C22.9988 11.0978 23.0788 10.9 23.2394 10.74C23.3999 10.58 23.5977 10.5 23.8327 10.5H24.666V9.66668C24.666 9.43057 24.746 9.23279 24.906 9.07335C25.066 8.9139 25.2638 8.8339 25.4994 8.83335C25.7349 8.83279 25.933 8.91279 26.0935 9.07335C26.2541 9.2339 26.3338 9.43168 26.3327 9.66668V10.5H27.166C27.4021 10.5 27.6002 10.58 27.7602 10.74C27.9202 10.9 27.9999 11.0978 27.9993 11.3333C27.9988 11.5689 27.9188 11.767 27.7593 11.9275C27.5999 12.0881 27.4021 12.1678 27.166 12.1667H26.3327V13C26.3327 13.2361 26.2527 13.4342 26.0927 13.5942C25.9327 13.7542 25.7349 13.8339 25.4994 13.8333C25.2638 13.8328 25.066 13.7528 24.906 13.5933C24.746 13.4339 24.666 13.2361 24.666 13V12.1667Z" fill="#5D3EF4"/>
                            </svg>
                            <h6 className="mt-2">Engagements</h6>
                            <h3 id="total-engagements-1">0</h3>
                        </div>
                    </div>

                    <hr/>

                    <div className="mt-4">
                        <h5 className="modal-title">Engagement by platform</h5>
                        <p className="text-muted mb-0" style={{fontSize: 13}}>Learn how your post is performing across platforms</p>
                    </div>

                    <div className="card card-view p-3 mt-3" style={{backgroundColor: "#F7F5FF"}}>
                        <img src="assets/img/fb-social.png" height="36" width="36" alt="facebook icon" />
                        <div className="d-flex justify-content-between align-items-center">
                            <div>
                                <h6 className="mt-2">Interactions</h6>
                                <div className="d-flex justify-content-between align-items-center">
                                    <h3 id="total-interactions-1">0</h3>
                                </div>
                            </div>

                            <div>
                                <h6 className="mt-2">Comments</h6>
                                <div className="d-flex justify-content-between align-items-center">
                                    <h3 id="total-comments-1">0</h3>
                                </div>
                            </div>

                            <div>
                                <h6 className="mt-2">Views - Reach</h6>
                                <div className="d-flex justify-content-between align-items-center">
                                    <h3 id="total-view-1">0</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="offcanvas-footer border-top p-3 d-grid" data-bs-dismiss="offcanvas" aria-label="Close">
                    <button className="btn btn-secondary">
                        Close
                    </button>
                </div>
            </div>

            <div className="modal fade" id="modalConfirm" tabIndex="-1" role="dialog" aria-labelledby="confirmation" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-sm" role="document">
                    <div className="modal-content tx-14">
                        <div className="modal-body">
                            <h6 className="data-message">Empty</h6>
                            <p className="mg-b-0 data-message-warning">This action cannot be undone</p>
                        </div>
                        <div className="modal-footer">
                            <div className="d-flex gap-2 w-100">
                                <button type="button" className="btn btn-outline-secondary w-50 mt-0" data-bs-dismiss="modal">Cancel</button>
                                <button type="button" id="delete-data" className="btn btn-danger w-50">Delete</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Assignment;
